module.exports = __webpack_public_path__ + "static/zombies-68fab6449c7d71e36e276bc318acab16.gif";